import { FilteredCommand, MultiselectCommand } from '../../core/model/command';
import { LeaseAgreementCategory } from '../model/const/enums';

export const leaseAgreementCommand = {
  approve: 'approve',
  createInvoice: 'createInvoice',
  export: 'export',
  exportNoPersonalData: 'exportNoPersonalData',
  linkDocument: 'linkDocument',
  print: 'print',
  printParkingForm: 'printParkingForm',
  printTerminationForm: 'printTerminationForm',
  showDocuments: 'showDocuments',
  showInvoices: 'showInvoices',
  terminate: 'terminate',
  withdrawApproval: 'withdrawApproval',
  withdrawTermination: 'withdrawTermination',
  void: 'void',
  sendForEsignDocument: 'eSignLeaseAgreementContract',
  esignKeyReciept: 'esignKeyReciept',
  transferCooperativeHousing: 'transferCooperativeHousing',
};

export class LeaseAgreementFilteredCommand extends FilteredCommand {
  constructor(
    id: string,
    excludedIds: string[],
    includedIds: string[],
    totalAffectedItemsControlValue: number,
    readonly category: LeaseAgreementCategory
  ) {
    super(id, excludedIds, includedIds, totalAffectedItemsControlValue);
  }
}

export class LeaseAgreementMultiselectCommand extends MultiselectCommand {
  constructor(id: string, items: any[], readonly category: LeaseAgreementCategory, itemsSource: any[], contextId?: string) {
    super(id, items, itemsSource, contextId);
  }
}
